import { browserHistory } from 'react-router';
import { routerReducer, routerMiddleware } from 'react-router-redux';
import { createStore, applyMiddleware, combineReducers } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import thunk from 'redux-thunk';
import mainReducers from 'reducers/mainReducers/mainReducers';
import apiReducers from 'reducers/apiReducers/apiReducers';
import httpReducers from 'reducers/httpReducers/httpReducers';
import facebookReducers from 'reducers/facebookReducers/facebookReducers';
import facebookInviteFriendsReducers from 'reducers/facebookInviteFriendsReducers/facebookInviteFriendsReducers';
import apiMiddleware from 'middlewares/apiMiddleware/apiMiddleware';

const configureStore = (initialState = {}) => {
  const middleware = [
    apiMiddleware,
    routerMiddleware(browserHistory),
    thunk,
  ];

  const reducer = combineReducers({
    routing: routerReducer,
    mainStore: mainReducers,
    facebookStore: facebookReducers,
    facebookInviteFriendsStore: facebookInviteFriendsReducers,
    api: apiReducers,
    http: httpReducers,
  });

  const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(applyMiddleware(...middleware)),
  );

  return store;
};

export default configureStore;



// WEBPACK FOOTER //
// ./configureStore.js